<template>
  <section class="longFormat">
    <h1 class="title"><span>Long Format</span></h1>
    <h2 class="longFormat__text monitor monitorHide">{{ pageCopy.description }}</h2>
    <Gallery :items="works" type="video" />
  </section>
</template>

<script>
import anime from 'animejs';
import Gallery from '../components/Gallery.vue';
export default {
  name: 'LongFormat',
  components: {
    Gallery
  },
  mounted() {
    setTimeout(() => {
      var elementList = document.querySelectorAll(".monitor");
      elementList.forEach(element => {
        var elementWatcher = scrollMonitor.create(element);
        elementWatcher.enterViewport(function () {
          element.classList.remove("monitorHide");
        });
        elementWatcher.exitViewport(function () {
          element.classList.add("monitorHide");
        });
      });
    }, 1000);
  },
  watch: {
    lang(newVal, oldVal) {
      setTimeout(() => {
        var elementList = document.querySelectorAll(".monitor");
        elementList.forEach(element => {
          var elementWatcher = scrollMonitor.create(element);
          elementWatcher.enterViewport(function () {
            element.classList.remove("monitorHide");
          });
          elementWatcher.exitViewport(function () {
            element.classList.add("monitorHide");
          });
        });
      }, 1000);
    }
  },
  computed: {
    works() {
      return this.$store.state.worksLongFormat;
    },
    pageCopy() {
      return this.$store.state.worksLongFormatCopy;
    },
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";

.longFormat {
  max-width: 1240px;

  span {
    display: inline-block;
  }

  &__text {
    font-family: CamptonBook;
    font-size: 20px;
    line-height: 1.35;
    color: var(--Neu01);
    opacity: 0;
    margin: 0 auto 40px;
    max-width: 1000px;
  }

  .monitor {
    opacity: 1;
    transition: all 0.5s ease-out 0.3s;
  }

  .monitorHide {
    opacity: 0 !important;
    transform: translateY(80px) !important;
  }

  @include mq(0, 768px) {}
}
</style>



// WEBPACK FOOTER //
// src/containers/LongFormat.vue